const getters = {
  lessonCompleted(state) {
    return state.completed;
  },
};

export default getters;
